import styled, { css } from "styled-components";

export const PopupWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const PopupContainer = styled.div`
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 450px;
  margin: 10% 10%;
  padding: 25px;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  font-family: "Mangueira Bold";
`;

export const TryAgainButton = styled.button`
  &.wrap-button {
    font-weight: bold;
    color: white;
    width: 11.4375rem;
    height: 3.5625rem;
    background: #3d8bff;
    border: 0.0625rem solid #3d8bff;
    border-radius: 4px;
  }
`;

export const TryAgainButtonWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end !important;
  margin-top: 18px;
`;

export const Container = styled.div``;

export const UnitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
  max-height: 216px;
  overflow: auto;
  margin-bottom: 8px;
  padding-right: 8px;

  ::-webkit-scrollbar-track {
    background-color: #efefef;
    border-radius: 8px;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background: #808495;
    border-radius: 8px;
  }
`;

type UnitItemProps = {
  selected: boolean;
};

export const UnitItem = styled.div<UnitItemProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  background-color: rgb(239, 239, 239);
  border-radius: 3px;
  padding: 8px;
  cursor: pointer;
  color: rgb(122, 122, 122);

  &:hover {
    background-color: rgb(0, 0, 255);
    color: rgb(255, 255, 255);
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: rgb(0, 0, 255);
      color: rgb(255, 255, 255);
    `}
`;

export const UnitItemTitle = styled.span`
  font-size: 12px;
  font-family: "Mangueira bold";
`;

export const UnitItemComplement = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 10px;
`;
